import {
  Component,
  OnInit,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
  Renderer2,
  OnDestroy,
} from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { LaunchDialogService } from '@spartacus/storefront'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { saveAs } from 'file-saver'
import { QuoteTrackingService } from '../quote-tracking.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { DatePipe } from '@angular/common'
import { QuoteCartService } from '../../quote-services/quote-cart.service'
import { filter, take } from 'rxjs/operators'
import {
  CurrentQuoteStatus,
  ORDER_TYPE_KEYS,
  QuoteStatus,
  StatusType,
} from '../../../../models/status/status.model'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../../shared/services/user-role.service'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { CommonService } from '../../../../shared/services/common.service'
import { QuoteStatusIndex } from '../../../../models/status/quote-status.model'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-quote-details',
  templateUrl: './quote-details.component.html',
  styleUrls: ['./quote-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuoteDetailsComponent implements OnInit, OnDestroy {
  public infoMsg = false

  expandAll = true
  public quoteDetail
  public quoteDetail$: Observable<any>
  currentOrderStatusId
  currentStatus = StatusType.QUOTE
  public loading
  tabcontent
  tablinks
  public noAttachment: boolean
  public id
  public shipToAddress
  public attachments
  public billToAddress
  public endUserAddress
  lineItems = []
  public quoteId: string
  public UG_VIEW_ONLY
  public currency
  public strTrim
  public jpyCurrency
  isReturned: boolean

  inquiryTypes
  QuoteStatus = QuoteStatus
  displayFormHideMessage: boolean = true
  public orderNumbers = []
  label
  // = [
  //   {
  //     code: 'gu',
  //     name: 'Government User'
  //   },
  //   {
  //     code: 'ngu',
  //     name: 'Non-Government User'
  //   }
  // ];
  CurrentQuoteStatus = CurrentQuoteStatus
  @ViewChild('defaultOpen') defaultOpen: ElementRef
  @ViewChild('categoryOne', { read: ElementRef }) categoryOne: ElementRef
  @ViewChild('categoryTwo', { read: ElementRef }) categoryTwo: ElementRef
  @ViewChild('categoryThree', { read: ElementRef }) categoryThree: ElementRef
  @ViewChild('categoryFour', { read: ElementRef }) categoryFour: ElementRef
  quotes: any[]
  inquiryForm: FormGroup
  isSubmitted: boolean
  public quoteLineItem = []
  public soldToAddSend = []
  public shipToAddSend = []
  public endAddSend = []
  public orderType
  editModal
  inquiryFormSubmitted: boolean = false
  fileExtension
  distinct: any[]
  cartId: string
  accessibility = ACCESSIBILITY
  downloadAllLoader: boolean
  downloadLoader = []
  dateObject: any
  cartEntriesLength: any
  constructor(
    protected globalMessageService: GlobalMessageService,
    private breadCrumbService: BreadcrumbService,
    private quoteTrackingService: QuoteTrackingService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private spinnerOverlayService: SpinnerOverlayService,
    private launchDialogService: LaunchDialogService,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private quoteCartService: QuoteCartService,
    private commonService: CommonService,
    private translate: TranslationService,
    private userRoleService: UserRoleService
  ) {
    this.isReturned = false
    this.noAttachment = false
  }

  ngAfterViewInit() {
    this.tabcontent = this.elRef.nativeElement.querySelectorAll('.tabcontent')
    this.tablinks = this.elRef.nativeElement.querySelectorAll('.tablinks')
    this.defaultOpen.nativeElement.click()
  }

  public openTab(evt, elementReference: ElementRef) {
    let i
    for (i = 0; i < this.tabcontent.length; i++) {
      this.tabcontent[i].style.display = 'none'
    }
    for (i = 0; i < this.tablinks.length; i++) {
      this.tablinks[i].className = this.tablinks[i].className.replace(
        ' active',
        ''
      )
    }
    this.renderer.setStyle(elementReference, 'display', 'block')
    if (this.categoryFour.nativeElement == elementReference) {
      this.expandAll = true
    }
    evt.currentTarget.className += ' active'

    this.resetInquiryForm()
  }
  get f() {
    return this.inquiryForm.controls
  }
  ngOnInit(): void {
    this.cartId = sessionStorage.getItem('cartId-current')
    this.currency = sessionStorage.getItem('currency')
    this.quoteTrackingService.getQuotesForMerge.subscribe((quotes) => {
      this.quotes = quotes
    })

    this.translate
      .translate('quoteTracking.myQuotes')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadCrumbs([
          {
            label: res,
            link: '/quote-list',
          },
        ])
      )
    this.inquiryForm = this.formBuilder.group({
      inquiryType: new FormControl(null, Validators.required),
      inquiryDescription: new FormControl(null, Validators.required),
    })

    this.activatedRoute.paramMap.subscribe((value: any) => {
      this.id = value.params.id
      this.quoteId = value.params.id
      this.translate
        .translate('quoteTracking.quoteOrder')
        .subscribe((res: string) => {
          this.label = res + this.id
          this.breadCrumbService.setBreadcrumbTitle(this.label)
        })
      /*  const breadcrum = 'quoteTracking.quoteInquiry' + this.id;
      this.breadCrumbService.setBreadcrumbTitle(breadcrum); */
      this.quoteTrackingService.getInquiryType().subscribe((success) => {
        if (success) {
          this.inquiryTypes = success['inquiryTypeValues']
        }
      })
      this.activatedRoute.queryParams.subscribe((params) => {
        this.dateObject = params
      })
      this.quoteDetail$ = this.quoteTrackingService.getQuoteDetailsFromList(
        this.id,
        this.dateObject.fromDate,
        this.dateObject.toDate
      )
      this.quoteDetail$.subscribe((res) => {
        this.quoteDetail = res
        if (this.quoteDetail?.isEditQuote === true) {
          // this.globalMessageService.add(
          //   'Quote is being edited',
          //   GlobalMessageType.MSG_TYPE_INFO,
          //   5000
          // );
          // window.scrollTo(0, 0);
          this.openEditedModel(this.QuoteStatus.EDIT)
        }
        if (this.quoteDetail?.isAcceptQuote === true) {
          // this.globalMessageService.add(
          //   'Quote is being edited',
          //   GlobalMessageType.MSG_TYPE_INFO,
          //   5000
          // );
          // window.scrollTo(0, 0);
          this.openEditedModel(this.QuoteStatus.ACCEPT)
        }
        if (this.quoteDetail?.isAdditionalQuote === true) {
          // this.globalMessageService.add(
          //   'Quote is being edited',
          //   GlobalMessageType.MSG_TYPE_INFO,
          //   5000
          // );
          // window.scrollTo(0, 0);
          this.openEditedModel(this.QuoteStatus.ADDITIONAL)
        }
        if (this.quoteDetail?.isMergeQuote === true) {
          // this.globalMessageService.add(
          //   'Quote is being edited',
          //   GlobalMessageType.MSG_TYPE_INFO,
          //   5000
          // );
          // window.scrollTo(0, 0);
          this.openEditedModel(this.QuoteStatus.MERGE)
        }
        this.quoteDetail?.quoteLineDetails.forEach((element) => {
          if (
            element?.orderNumber &&
            element?.orderNumber !== '' &&
            element.orderNumber != null
          ) {
            this.orderNumbers.push(element.orderNumber)
          }
        })
        this.distinct = [...new Set(this.orderNumbers.map((x) => x))]
        if (this.quoteDetail.quoteDetailsList.quoteStatusCode == 'RVS') {
          this.isReturned = true
        }
        switch (this.quoteDetail.quoteDetailsList.quoteStatusCode) {
          case 'RVS':
            this.currentOrderStatusId = QuoteStatusIndex.PENDING
            break

          case 'IP':
            this.currentOrderStatusId = QuoteStatusIndex.PROGRESS
            break

          case 'PENDING':
            this.currentOrderStatusId = QuoteStatusIndex.PENDING
            break

          case 'CLS':
            this.currentOrderStatusId = QuoteStatusIndex.CLOSED
            break

          case 'EXP':
            this.currentOrderStatusId = QuoteStatusIndex.EXPIRED
            break
        }
      })
      this.quoteTrackingService.getAllDocuments(this.id).subscribe(
        (response) => {
          this.attachments = response
          if (response !== undefined && response !== null) {
            this.attachments = this.attachments.documentsList
            if (this.attachments == undefined) {
              this.noAttachment = true
            } else {
              for (let i = 0; i < this.attachments.length; i++) {
                if (this.attachments[i].fileType == 'xls') {
                  this.fileExtension = 'xlsx'
                  this.attachments[i].fileExtension = this.fileExtension
                } else {
                  this.fileExtension = this.attachments[i].fileType
                  this.attachments[i].fileExtension = this.fileExtension
                }
              }
            }
          }
        },
        (error) => {
          this.globalMessageService.add(
            { key: 'quoteTracking.issueFetchingAssociatedDoc' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    })
    this.quoteTrackingService.getRolesOfcust().subscribe((res) => {
      this.UG_VIEW_ONLY = res
    })
  }

  // sumbitInquiry() {
  //   this.isSubmitted = true;

  //   if (this.inquiryForm.invalid) {
  //     return;
  //   }
  // }

  submitInquiry(id, refrence, date) {
    this.inquiryFormSubmitted = true
    if (this.inquiryForm.valid) {
      this.quoteTrackingService
        .submitInquiryToCSR(
          this.inquiryForm.value.inquiryType,
          this.inquiryForm.value.inquiryDescription,
          id,
          refrence,
          date
        )
        .subscribe(
          (response) => {
            this.displayFormHideMessage = false
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'quoteTracking.issuePostingQuery' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  resetInquiryForm() {
    this.inquiryFormSubmitted = false
    this.inquiryForm.reset()
    this.displayFormHideMessage = true
  }
  openEditedModel(operation) {
    const componentdata = {
      operation: operation,
    }

    const editedQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.EDITED_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (editedQuoteDialog) {
      editedQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }
  repeatQuote() {
    this.spinnerOverlayService.show()
    this.quoteDetail?.quoteLineDetails.forEach((element) => {
      var lineItem = {
        brandCode: '',
        brandName: '',
        code: '',
        comment: '',
        csrResponseRequired: true,
        customerRequestedDate: '',
        isUnsolicited: true,
        productType: '',
        quantity: 0,
        quoteCartEntryType: '',
        quoteExtendedPrice: 0,
        quoteNetPrice: 0,
        listPrice: 0,
        reasonForQuote: '',
        rfqPartDescription: '',
        rfqPartNumber: '',
        serialNumber: '',
        tagNumber: '',
        itemNumber: '',
      }

      lineItem = {
        csrResponseRequired: true,
        brandCode: 'ECOM_LVL1_10300000',
        brandName: 'MASONEILAN',
        comment: '',
        customerRequestedDate: element.requestedShipDate.replace(/-/g, '/'),
        code: element.partNumber,
        isUnsolicited: false,
        productType: 'Part',
        quantity: Number(element.quantity),
        reasonForQuote: '',
        quoteExtendedPrice: Number(element.quoteExtendedPrice),
        quoteNetPrice: Number(element.quoteNetPrice),
        listPrice: Number(element?.listPrice),
        rfqPartDescription: element.partDescription,
        serialNumber: element.serialNumber,
        rfqPartNumber: element.partNumber,
        tagNumber: element.tagNumber,
        quoteCartEntryType: 'COPY',
        itemNumber: element.itemNumber,
      }
      this.lineItems.push(lineItem)
    })
    var ship = this.quoteDetail?.quoteDetailsList.shipToAddress.split(';')
    this.shipToAddress = {
      partnerNumber: ship[0],
      companyName: ship[1],
      line1: ship[2],
      line2: ship[3],
      town: ship[4],
      region: {
        isocode: `${ship[7]}-${ship[6]}`,
      },
      country: {
        isocode: ship[7],
      },
      postalCode: ship[8],
    }
    var sold = this.quoteDetail?.quoteDetailsList.soldToAddress.split(';')
    this.billToAddress = {
      companyName: sold[0],
      line1: sold[1],
      line2: sold[2],
      town: sold[3],
      region: {
        isocode: `${sold[6]}-${sold[5]}`,
      },
      country: {
        isocode: sold[6],
      },
      postalCode: sold[7],
    }
    var end = this.quoteDetail?.quoteDetailsList.endUserAddresss.split(';')
    this.endUserAddress = {
      partnerNumber: end[0],
      companyName: end[1],
      line1: end[2],
      line2: end[3],
      town: end[4],
      region: {
        isocode: `${end[7]}-${end[6]}`,
      },
      country: {
        isocode: end[7],
      },
      postalCode: end[8],
    }
    var quoteObject = {
      billToAddress: this.billToAddress,
      deliveryAddress: this.shipToAddress,
      endUserAddress: this.endUserAddress,
      quoteCartType: 'COPY',
      quoteEntries: this.lineItems,
      rfqType: this.quoteDetail.quoteDetailsList?.rfqType,
      customerProjectName:
        this.quoteDetail?.quoteDetailsList?.customerProjectName,
      endUserIndustry: this.quoteDetail?.quoteDetailsList?.endUserIndustry,
      notificationEmail: this.quoteDetail?.quoteDetailsList?.notificationEmail,
      quoteId: this.quoteId,
    }
    this.quoteTrackingService.editQuote(quoteObject).subscribe(
      (success) => {
        this.spinnerOverlayService.hide()
        this.setSession(success['cartCode'], function () {})
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'quoteTracking.ErrorPerformingAction' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  setSession(cartId, callback) {
    sessionStorage.setItem('cartId-current', cartId)
    // if(this.cartEntriesLength > 0)
    sessionStorage.setItem('cartStatus-current', 'empty')
    this.router.navigate(['quote/cart'])
    callback()
  }
  updateQuotes(event) {}

  generateFileName(document) {
    return document.fileName
  }
  documentDownloadingLoader: boolean = false

  downloadDocument(document, index?) {
    this.downloadLoader[index] = true
    let docNumber = document.docNumber
    let docType = document.docType
    let fileName = document.fileName
    let fileType = document.fileType

    this.quoteTrackingService
      .downloadAssociatedDocument(docNumber, docType, fileName, fileType)
      .subscribe(
        (res) => {
          this.downloadLoader[index] = false
          let count = 0
          this.downloadLoader.map((element, index) => {
            if (element === true) {
              count++
            }
          })
          if (count > 0 && this.downloadAllLoader === true) {
          } else {
            this.downloadAllLoader = false
          }
          if (res !== null && res !== undefined) {
            let fileName = document.fileName
            if (fileType == 'pdf') {
              const blob = new Blob([res], { type: 'application/pdf' })
              const file = new File([blob], fileName + '.pdf', {
                type: 'application/pdf',
              })
              saveAs(file)
            } else if (fileType == 'doc' || fileType == 'docx') {
              const blob = new Blob([res], { type: 'application/msword' })
              const file = new File([blob], fileName + '.doc', {
                type: 'application/msword',
              })
              saveAs(file)
            } else if (fileType == 'jpg' || fileType == 'JPG') {
              const blob = new Blob([res], { type: 'application/jpeg' })
              const file = new File([blob], fileName + '.jpg', {
                type: 'application/jpeg',
              })
              saveAs(file)
            } else if (fileType == 'png' || fileType == 'PNG') {
              const blob = new Blob([res], { type: 'application/png' })
              const file = new File([blob], fileName + '.png', {
                type: 'application/png',
              })
              saveAs(file)
            } else if (fileType == 'xls' || fileType == 'xlsx') {
              const blob = new Blob([res], {
                type: 'application/vnd.ms-excel',
              })
              const file = new File([blob], fileName + '.xlsx', {
                type: 'application/vnd.ms-excel',
              })
              saveAs(file)
            }
          } else {
            this.displayDownloadError(document)
          }
        },
        (error) => {
          this.downloadLoader[index] = false

          this.downloadAllLoader = false
          this.displayDownloadError(document)
        }
      )
  }

  downloadAllFiles() {
    this.attachments.forEach((document, index) => {
      this.downloadAllLoader = true
      this.downloadDocument(document, index)
    })
  }

  displayDownloadError(document) {
    this.globalMessageService.add(
      { key: 'quoteTracking.issueDownloadingDoc' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }
  ngOnDestroy() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
  }

  getOrderTypeValue(key) {
    this.orderType = ORDER_TYPE_KEYS.get(key)
    return ORDER_TYPE_KEYS.get(key)
  }

  downloadPDF() {
    this.quoteLineItem = []
    this.shipToAddSend = []
    this.shipToAddSend = []
    this.endAddSend = []
    let soldToAdd = this.quoteDetail?.quoteDetailsList.soldToAddress.split(';')
    let shipToAdd = this.quoteDetail?.quoteDetailsList.shipToAddress.split(';')
    let endAdd = this.quoteDetail?.quoteDetailsList.endUserAddresss.split(';')
    this.soldToAddSend = [
      soldToAdd[0],
      soldToAdd[2],
      soldToAdd[3],
      soldToAdd[4],
      soldToAdd[5],
      soldToAdd[6],
      soldToAdd[7],
    ]

    this.shipToAddSend = [
      shipToAdd[1],
      shipToAdd[3],
      shipToAdd[4],
      shipToAdd[5],
      shipToAdd[6],
      shipToAdd[7],
      shipToAdd[8],
    ]

    this.endAddSend = [
      endAdd[1],
      endAdd[3],
      endAdd[4],
      endAdd[5],
      endAdd[6],
      endAdd[7],
      endAdd[8],
    ]

    for (let i = 0; i < this.quoteDetail.quoteLineDetails.length; i++) {
      let lineItems = {
        additionalComments:
          this.quoteDetail?.quoteLineDetails[i].additionalComments,
        fieldCsr: this.quoteDetail?.quoteLineDetails[i].fieldCsr,
        itemNumber: this.quoteDetail?.quoteLineDetails[i].itemNumber,
        orderNumber: this.quoteDetail?.quoteLineDetails[i].orderNumber,
        partDescription: this.quoteDetail?.quoteLineDetails[i].partDescription,
        partNumber: this.quoteDetail?.quoteLineDetails[i].partNumber,
        quantity: this.quoteDetail?.quoteLineDetails[i].quantity,
        quoteExtendedPrice:
          this.quoteDetail?.quoteLineDetails[i].quoteExtendedPrice,
        listPrice: this.quoteDetail?.quoteLineDetails[i]?.listPrice,
        quoteNetPrice: this.quoteDetail?.quoteLineDetails[i].quoteNetPrice,
        quoteStatusCode: this.quoteDetail?.quoteLineDetails[i].quoteStatusCode,
        quoteStatusLabel:
          this.quoteDetail?.quoteLineDetails[i].quoteStatusLabel,
        reasonForRejection:
          this.quoteDetail?.quoteLineDetails[i].reasonForRejection,
        requestedShipDate: this.datepipe.transform(
          this.quoteDetail?.quoteLineDetails[i].requestedShipDate,
          'dd MMM yyyy'
        ),
        serialNumber: this.quoteDetail?.quoteLineDetails[i].serialNumber,
        tagNumber: this.quoteDetail?.quoteLineDetails[i].tagNumber,
        quoteLeadTime: this.quoteDetail?.quoteLineDetails[i].quoteLeadTime,
      }
      this.quoteLineItem.push(lineItems)
    }
    let Obj = {
      isEditQuote: false,
      quoteDetailsList: {
        createdDate: this.quoteDetail?.quoteDetailsList.createdDate,
        customerProjectName:
          this.quoteDetail?.quoteDetailsList?.customerProjectName,
        endUserAddresss: this.endAddSend.toString(),
        endUserIndustry: this.quoteDetail?.quoteDetailsList?.endUserIndustry,
        expirationDate: this.quoteDetail?.quoteDetailsList.expirationDate,
        notificationEmail:
          this.quoteDetail?.quoteDetailsList?.notificationEmail,
        quoteCreatedBy: this.quoteDetail?.quoteDetailsList.quoteCreatedBy,
        quoteId: this.id,
        quoteReference: this.quoteDetail.quoteDetailsList.quoteReference,
        quoteStatusCode: this.quoteDetail?.quoteDetailsList.quoteStatusCode,
        quoteStatusLabel: this.quoteDetail?.quoteDetailsList.quoteStatusLabel,
        quoteTotal: this.quoteDetail?.quoteDetailsList.quoteTotal,
        rfqType: this.orderType,
        shipToAddress: this.shipToAddSend.toString(),
        soldToAddress: this.soldToAddSend.toString(),
      },
      quoteLineDetails: this.quoteLineItem,
    }

    this.quoteTrackingService.downloadQuoteDetails(Obj).subscribe(
      (res: any) => {
        let fileName = 'QuoteDetail_' + this.quoteId
        saveAs(res, fileName)
      },
      (error) => {
        this.displayDownloadError
      }
    )
  }

  downloadEXCEL() {
    this.quoteLineItem = []
    this.shipToAddSend = []
    this.shipToAddSend = []
    this.endAddSend = []
    let soldToAdd = this.quoteDetail?.quoteDetailsList.soldToAddress.split(';')
    let shipToAdd = this.quoteDetail?.quoteDetailsList.shipToAddress.split(';')
    let endAdd = this.quoteDetail?.quoteDetailsList.endUserAddresss.split(';')
    this.soldToAddSend = [
      soldToAdd[0],
      soldToAdd[2],
      soldToAdd[3],
      soldToAdd[4],
      soldToAdd[5],
      soldToAdd[6],
      soldToAdd[7],
    ]

    this.shipToAddSend = [
      shipToAdd[1],
      shipToAdd[3],
      shipToAdd[4],
      shipToAdd[5],
      shipToAdd[6],
      shipToAdd[7],
      shipToAdd[8],
    ]

    this.endAddSend = [
      endAdd[1],
      endAdd[3],
      endAdd[4],
      endAdd[5],
      endAdd[6],
      endAdd[7],
      endAdd[8],
    ]

    for (let i = 0; i < this.quoteDetail.quoteLineDetails.length; i++) {
      let lineItems = {
        additionalComments:
          this.quoteDetail?.quoteLineDetails[i].additionalComments,
        fieldCsr: this.quoteDetail?.quoteLineDetails[i].fieldCsr,
        itemNumber: this.quoteDetail?.quoteLineDetails[i].itemNumber,
        orderNumber: this.quoteDetail?.quoteLineDetails[i].orderNumber,
        partDescription: this.quoteDetail?.quoteLineDetails[i].partDescription,
        partNumber: this.quoteDetail?.quoteLineDetails[i].partNumber,
        quantity: this.quoteDetail?.quoteLineDetails[i].quantity,
        quoteExtendedPrice:
          this.quoteDetail?.quoteLineDetails[i].quoteExtendedPrice,
        listPrice: this.quoteDetail?.quoteLineDetails[i]?.listPrice,
        quoteNetPrice: this.quoteDetail?.quoteLineDetails[i].quoteNetPrice,
        quoteStatusCode: this.quoteDetail?.quoteLineDetails[i].quoteStatusCode,
        quoteStatusLabel:
          this.quoteDetail?.quoteLineDetails[i].quoteStatusLabel,
        reasonForRejection:
          this.quoteDetail?.quoteLineDetails[i].reasonForRejection,
        requestedShipDate: this.datepipe.transform(
          this.quoteDetail?.quoteLineDetails[i].requestedShipDate,
          'dd MMM yyyy'
        ),
        serialNumber: this.quoteDetail?.quoteLineDetails[i].serialNumber,
        tagNumber: this.quoteDetail?.quoteLineDetails[i].tagNumber,
        quoteLeadTime: this.quoteDetail?.quoteLineDetails[i].quoteLeadTime,
      }
      this.quoteLineItem.push(lineItems)
    }
    let Obj = {
      isEditQuote: false,
      quoteDetailsList: {
        createdDate: this.quoteDetail?.quoteDetailsList.createdDate,
        customerProjectName:
          this.quoteDetail?.quoteDetailsList?.customerProjectName,
        endUserAddresss: this.endAddSend.toString(),
        endUserIndustry: this.quoteDetail?.quoteDetailsList?.endUserIndustry,
        expirationDate: this.quoteDetail?.quoteDetailsList.expirationDate,
        notificationEmail:
          this.quoteDetail?.quoteDetailsList?.notificationEmail,
        quoteCreatedBy: this.quoteDetail?.quoteDetailsList.quoteCreatedBy,
        quoteId: this.id,
        quoteReference: this.quoteDetail.quoteDetailsList.quoteReference,
        quoteStatusCode: this.quoteDetail?.quoteDetailsList.quoteStatusCode,
        quoteStatusLabel: this.quoteDetail?.quoteDetailsList.quoteStatusLabel,
        quoteTotal: this.quoteDetail?.quoteDetailsList.quoteTotal,
        rfqType: this.orderType,
        shipToAddress: this.shipToAddSend.toString(),
        soldToAddress: this.soldToAddSend.toString(),
      },
      quoteLineDetails: this.quoteLineItem,
    }

    this.quoteTrackingService
      .downloadQuoteDetailsExcel(Obj)
      .subscribe((res) => {
        let fileName = 'QuoteDetail_' + this.quoteId
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        const file = new File([blob], fileName + '.xlsx', {
          type: 'application/vnd.ms-excel',
        })

        saveAs(file)
      })
  }

  openModal() {
    this.spinnerOverlayService.show()
    // this.globalMessageService.add(
    //   { key: 'quoteTracking.undefinedPart' },
    //   GlobalMessageType.MSG_TYPE_WARNING,
    //   8000
    // )
    window.scrollTo(0, 0)
    this.quoteCartService.getCart(this.cartId, 'current').subscribe((data) => {
      this.spinnerOverlayService.hide()
      // this.cartEntriesLength = data['entries']?.length;
      if (data['entries']?.length > 0) {
        const componentdata = {}

        const quoteEditDialog = this.launchDialogService.openDialog(
          VS_LAUNCH_CALLER.QUOTE_EDIT,
          undefined,
          undefined,
          componentdata
        )
        if (quoteEditDialog) {
          quoteEditDialog.pipe(take(1)).subscribe((value) => {})
          this.launchDialogService.dialogClose
            .pipe(
              filter(
                (dialogResponse: DialogResponse) =>
                  dialogResponse?.type == VS_LAUNCH_CALLER.QUOTE_EDIT
              ),
              take(1)
            )
            .subscribe((value) => {
              if (value?.reason === 'quote-edit') {
                this.repeatQuote()
              } else {
              }
            })
        }
      } else {
        this.spinnerOverlayService.hide()
        this.repeatQuote()
      }
    })
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }

  getNetPrice(netPrice) {
    if (netPrice.indexOf('JPY') != -1) {
      this.jpyCurrency = netPrice.split('.')
      return this.jpyCurrency[0]
    } else {
      return netPrice
    }
  }
}
